import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var Reflect01 = function Reflect01(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M12 3v3m0 4.5v3m0 4.5v3M3.2878 7.9906l4.3879 3.3753c.2805.2158.4207.3236.4711.4551a.5.5 0 0 1 0 .358c-.0504.1315-.1906.2393-.4711.4551l-4.388 3.3753c-.4135.3182-.6204.4773-.7938.4751a.5.5 0 0 1-.3864-.1902C2 16.1581 2 15.8971 2 15.3753V8.6247c0-.5218 0-.7828.1075-.919a.5.5 0 0 1 .3864-.1902c.1734-.0022.3803.157.7939.475m17.4244 0-4.3879 3.3753c-.2805.2158-.4207.3236-.4711.4551a.5.5 0 0 0 0 .358c.0504.1315.1906.2393.4711.4551l4.3879 3.3753c.4136.3182.6205.4773.7939.4751a.5.5 0 0 0 .3864-.1902C22 16.158 22 15.897 22 15.3752V8.6247c0-.5218 0-.7828-.1075-.919a.5.5 0 0 0-.3864-.1902c-.1734-.0022-.3803.157-.7939.475"
    })
  }));
};
export default Reflect01;